import React from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import Artical from './artical';
import ShangChengEwm from './shangchengewm';
import JingPin from './jingPin';
import KeFuEwm from './kefuewm';

class LeftContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        current: 0,
    };

    handleChangeTab = index => {
        this.setState({
            current: index,
        });
    };

    render() {
        const { current } = this.state;
        const {
            content: {
                article,
                shangchengewm,
                jingping,
                kefuewm,
                hasCopyRight,
                faceUrl,
                vestAccountDetail,
                subscribe,
                keywords,
                interact,
                sourceReason,
            },
        } = this.props;

        return (
            <div className={styles.leftContent}>
                <Artical
                    content={article}
                    hasCopyRight={hasCopyRight}
                    faceUrl={faceUrl}
                    vestAccountDetail={vestAccountDetail}
                    subscribe={subscribe}
                    keywords={keywords}
                    interact={interact}
                    sourceReason={sourceReason}
                />
                <div className={styles.bottomNew}>
                    <Chip id="50045" type="struct" title="商城二维码" groupName="底边栏" content={shangchengewm}>
                        <ShangChengEwm />
                    </Chip>
                    <Chip id="50046" type="struct" title="梧桐汇精品" groupName="底边栏" content={jingping}>
                        <JingPin current={current} handleChangeTab={this.handleChangeTab} />
                    </Chip>
                    <Chip id="50048" type="struct" title="客服微信二维码" groupName="底边栏" content={kefuewm}>
                        <KeFuEwm />
                    </Chip>
                </div>
            </div>
        );
    }
}

export default errorBoundary(LeftContent);
